import {Theme} from '@lookiero/aurora';
import {StyleSheet} from 'react-native';

const {space2, space4} = Theme.get();

const style = () =>
  StyleSheet.create({
    panel: {
      paddingLeft: space2,
      paddingRight: space2,
      height: 55,
    },
    panelLarge: {
      paddingRight: space4,
      width: undefined,
      display: 'flex',
      flexDirection: 'row',
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      placeContent: 'center',
      alignItems: 'center',
    },
  });

export {style};
